import { PcpCommandBarModule } from './../../../../pcpcommandbar/pcp-commandbar.module';
import { RecordableNotificationsModule } from './recordable.notifications/recordable.notifications.module';
import { AddEditNotificationsComponent } from './addeditnotifications.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { ChangeOrderNotificationsModule } from './changeorder.notifications/changeorder.notifications.module';
import { DrawerModule } from 'primeng/drawer';

@NgModule({
    imports: [
        ChangeOrderNotificationsModule,
        CommonModule,
        SelectModule,
        FormsModule,
        PcpCommandBarModule,
        RecordableNotificationsModule,
        DrawerModule,
        AddEditNotificationsComponent
    ],
    exports: [AddEditNotificationsComponent]
})
export class AddEditNotificationsModule { }
